import { fetcherWithToken } from '@/shared/api/fetcher';
import useSWRMutation from 'swr/mutation';

export const useLoginGoogle = () => {
  const { trigger } = useSWRMutation('/login/google', (url, { arg }) =>
    fetcherWithToken(url, {
      method: 'POST',
      body: JSON.stringify(arg),
    })
  );

  return {
    trigger,
  };
};
